import { render } from "./PromoDetailView.vue?vue&type=template&id=c940ca30&scoped=true"
import script from "./PromoDetailView.vue?vue&type=script&lang=js"
export * from "./PromoDetailView.vue?vue&type=script&lang=js"

import "./PromoDetailView.vue?vue&type=style&index=0&id=c940ca30&scoped=true&lang=css"
import "./PromoDetailView.vue?vue&type=style&index=1&id=c940ca30&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c940ca30"]])

export default __exports__